import { render, staticRenderFns } from "./ticket-status-badge.vue?vue&type=template&id=a6c6aa24&scoped=true&"
import script from "./ticket-status-badge.vue?vue&type=script&lang=js&"
export * from "./ticket-status-badge.vue?vue&type=script&lang=js&"
import style0 from "./ticket-status-badge.vue?vue&type=style&index=0&id=a6c6aa24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c6aa24",
  null
  
)

export default component.exports